<template>
        <router-view></router-view>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
      };
    },
    methods: {
      
    },
    created () {
        
    }
}
</script>
<style>

</style>
